module.exports = __webpack_public_path__ + "front/img/20.61ab1a6e.png";